module.exports = new __parcel__URL__("browser1.05f8e65f.png").toString();